// src/components/SessionTimeoutModal.jsx

import { useEffect, useRef, useState } from 'react';
import useModalA11y from '../hooks/useModalA11y';

const SessionTimeoutModal = ({ visible, duration = 300, onContinue, onLogout }) => {
  const [remaining, setRemaining] = useState(duration);
  const dialogRef = useRef(null);

  useEffect(() => {
    if (!visible) return;

    setRemaining(duration);

    const interval = setInterval(() => {
      setRemaining((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          onLogout();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [visible, duration]);

  useModalA11y({
    isOpen: visible,
    dialogRef,
    closeOnEscape: false,
  });

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? '0' : ''}${s}`;
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="sessionTimeoutTitle"
        tabIndex={-1}
        className="bg-highlight-light border border-highlight-dark rounded-2xl shadow-2xl p-6 max-w-sm w-full text-center"
      >
        <h2 id="sessionTimeoutTitle" className="text-xl font-bold text-primary mb-2">Session Expiring</h2>
        <p className="text-neutral-dark mb-4">
          Your session will expire in <span className="font-semibold text-secondary-dark">{formatTime(remaining)}</span>
        </p>

        <div className="flex justify-center space-x-4">
          <button
            type="button"
            onClick={onContinue}
            className="px-5 py-2 rounded-xl text-white bg-button hover:bg-button-light transition duration-200 font-medium"
          >
            Continue Session
          </button>
          <button
            type="button"
            onClick={onLogout}
            className="px-5 py-2 rounded-xl text-white bg-neutral-dark hover:bg-neutral transition duration-200 font-medium"
          >
            Logout Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionTimeoutModal;
